/* ============================================================
   Cloud Store · Club VIP dans le panier : attributs de panier
   - « 10 g offerts (VIP Or) » : choix de la variété (menu [data-cs-vip-pick], VIP Or seulement,
     panier >= palier des 10 g offerts) ; vidé dès que le panier repasse sous le palier.
   - « Club VIP » : « VIP » ou « VIP Or » posé automatiquement pour un client VIP connecté,
     jamais pour un non-VIP (repère de la commande à la préparation).
   Le niveau et le seuil viennent du <div data-cs-vip-config> de sections/cs-cart-drawer.liquid ;
   l'état du panier vient de l'événement cs:cart:loaded de cs-cart.js. N'ajoute aucun appel si rien ne change.
   ============================================================ */
(function () {
  'use strict';
  if (window.__csCartVipInit) return;
  window.__csCartVipInit = true;

  // /en : cs-cart.js recharge le tiroir avec « /?sections=cs-cart-drawer » (racine = français), donc les lignes Club VIP
  // du tiroir s'afficheraient en français sur /en. On préfixe cette seule URL avec la racine de la langue ; rien d'autre ne change.
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT !== '/' && typeof window.fetch === 'function') {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      if (typeof input === 'string' && input.indexOf('/?sections=cs-cart-drawer') === 0) {
        input = ROOT + input.slice(1);
      }
      return nativeFetch.call(this, input, init);
    };
  }

  var PICK_KEY = '10 g offerts (VIP Or)';
  var VIP_KEY = 'Club VIP';
  var busy = false;
  var retries = 0;

  function config() {
    var el = document.querySelector('[data-cs-vip-config]');
    if (!el) return null;
    return { level: el.getAttribute('data-level') || '', t2: parseInt(el.getAttribute('data-t2') || '0', 10) || 0 };
  }

  function postAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function reconcile(cart) {
    var c = config();
    if (!c || !cart || busy) return;
    var attrs = cart.attributes || {};
    var want = {};

    var vipWanted = c.level === 'or' ? 'VIP Or' : (c.level === 'vip' ? 'VIP' : '');
    var curVip = attrs[VIP_KEY] || '';
    if (vipWanted) {
      if (cart.item_count > 0 && curVip !== vipWanted) want[VIP_KEY] = vipWanted;
    } else if (curVip) {
      want[VIP_KEY] = '';
    }

    var curPick = attrs[PICK_KEY] || '';
    if (curPick) {
      var eligible = c.level === 'or' && c.t2 > 0 && cart.total_price >= c.t2;
      var stale = !eligible;
      if (!stale) {
        // le menu est affiché mais la variété choisie n'y figure plus (épuisée entre-temps)
        var sel = document.querySelector('[data-cs-vip-pick]');
        if (sel && !Array.prototype.some.call(sel.options, function (o) { return o.value === curPick; })) stale = true;
      }
      if (stale) want[PICK_KEY] = '';
    }

    if (!Object.keys(want).length || retries > 3) return;
    retries += 1;
    busy = true;
    postAttributes(want).catch(function () { /* réessayé au prochain événement du panier */ }).then(function () {
      busy = false;
    });
  }

  document.addEventListener('cs:cart:loaded', function (e) { reconcile(e && e.detail); });

  // Choix de la variété : enregistré sans recharger ; les 2 menus (tiroir + page panier) restent alignés.
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-cs-vip-pick]') : null;
    if (!sel) return;
    var value = sel.value;
    var previous = sel.getAttribute('data-prev') || '';
    document.querySelectorAll('[data-cs-vip-pick]').forEach(function (other) { if (other !== sel) other.value = value; });
    var attrs = {};
    attrs[PICK_KEY] = value;
    postAttributes(attrs).then(function (res) {
      if (!res.ok) throw new Error('update ' + res.status);
      document.querySelectorAll('[data-cs-vip-pick]').forEach(function (s) { s.setAttribute('data-prev', value); });
    }).catch(function () {
      document.querySelectorAll('[data-cs-vip-pick]').forEach(function (s) { s.value = previous; });
    });
  });
  document.addEventListener('focusin', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-cs-vip-pick]') : null;
    if (sel) sel.setAttribute('data-prev', sel.value);
  });
})();
